import { render } from "./MainAbout.vue?vue&type=template&id=42913676"
import script from "./MainAbout.vue?vue&type=script&lang=js"
export * from "./MainAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__